import React from 'react';

import { AssessmentViewModel } from '@/api';
import { globalEnums } from '@/shared/duck';
import { AssessmentsContext } from '@/shared/providers';

const AssessmentsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [viewType, setViewType] = React.useState<globalEnums.EAssessmentsViewType>(globalEnums.EAssessmentsViewType.RIBBON);
  const [selectedAssessment, setSelectedAssessment] = React.useState<AssessmentViewModel>();

  const initialValues = {
    viewType,
    setViewType,
    selectedAssessment,
    setSelectedAssessment,
  };

  return (
    <AssessmentsContext.Provider value={initialValues}>
      {children}
    </AssessmentsContext.Provider>
  );
};

export default AssessmentsProvider;